
































import { Vue, Component, Prop } from 'vue-property-decorator';
import draggable from 'vuedraggable';

@Component({
  components: {
    draggable
  }
})
export default class SpeedList extends Vue {
  // Props
  @Prop(Array) public list!: object[];
  @Prop(Boolean) public isReadOnly!: boolean;

  public addItem() {
    this.list.push({ speed: '' });
  }
  public deleteItem(index) {
    this.list.splice(index, 1);
  }
}
